import handler from 'services/httpHandler'

export const get = (resource = '') => handler.get({
  url: `/dental/plans/family${resource}`,
  options: {
    mode: 'cors'
  }
})

export const getDetails = (planCode) => handler.get({
  url: `/dental/plan/${planCode}/details`,
  options: {
    mode: 'cors'
  }
})

export const getByCode = code => handler.get({
  url: `/dental/${code}/plan`,
  options: {
    mode: 'cors'
  }
})

export const getPlanFilter = async params => handler.get({
  url:'/dental/plans/filter',
  params,
  options: {
    mode: 'cors'
  },
})
